import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from '../Layouts';

// Routes
import { authProtectedRoutes, publicRoutes , openRoutes } from './allRoutes';
import NonAuthLayout from '../Layouts/NonAuthLayout';
import AuthProtected from './Authprotected';
import SignIn from '../pages/AuthenticationInner/SignIn';
import ConditionalLayout from '../Layouts/ConditionalLayout';

const RoutesComponents = () => {
  return (
    <React.Fragment>
      <Routes>

        {/* ------------------------------------
            1️⃣ OPEN ROUTES (Mixed Layouts)
        ------------------------------------- */}
        {openRoutes.map((route, idx) => (
          <Route
            key={`open-${idx}`}
            path={route.path}
            element={
              <ConditionalLayout>
                {route.component}
              </ConditionalLayout>
            }
          />
        ))}

        {/* ------------------------------------
            2️⃣ PUBLIC ROUTES (No Sidebar)
        ------------------------------------- */}
        {publicRoutes.map((route, idx) => (
          <Route
            key={`public-${idx}`}
            path={route.path}
            element={
              <NonAuthLayout>
                {route.component}
              </NonAuthLayout>
            }
          />
        ))}

        {/* ------------------------------------
            3️⃣ AUTH PROTECTED ROUTES (Sidebar + Header)
        ------------------------------------- */}
        {authProtectedRoutes.map((route, idx) => (
          <Route
            key={`auth-${idx}`}
            path={route.path}
            element={
              <AuthProtected>
                <Layout>
                  {route.component}
                </Layout>
              </AuthProtected>
            }
          />
        ))}

      </Routes>
    </React.Fragment>
  );
};


export default RoutesComponents;